/**
 * Removes "org", "organization", or "space" prefix from role titles
 * @example "Org Admin" -> "Admin"
 * @example "Organization Owner" -> "Owner"
 * @example "Space Editor" -> "Editor"
 */
export function stripOrgPrefix(title: string): string {
  return title.replace(/^(org|organization|space)\s+/i, "");
}
